import { Component } from '@angular/core';
import { PoDatepickerIsoFormat } from '@po-ui/ng-components';
import { defaultIFiltroSaidasFazendas, IFiltroSaidasFazendas, SaidasRelatorios } from '../../interface/saidas-fazendas';
import { PedidoService } from '../../service/pedido.service';
import { ExcelService } from 'src/app/service/excel-service';

@Component({
  selector: 'app-saidas-fazendas',
  templateUrl: './saidas-fazendas.component.html',
  styleUrl: './saidas-fazendas.component.css'
})
export class SaidasFazendasComponent {

  formatBasic: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Basic;

  filtrosPrincipal: IFiltroSaidasFazendas = defaultIFiltroSaidasFazendas();
  itemsExcel: Array<SaidasRelatorios> = [];

  constructor(
    private excelService: ExcelService,
    private pedidoService: PedidoService,
  ){};

  loadDados(): void {
    this.pedidoService.getSaidasFazendasLista(this.filtrosPrincipal).subscribe((ret)=>{
      this.itemsExcel = ret.items;
      this.gerarExcel();
    })
  };

  gerarExcel(): void {
    const lista_excel = this.itemsExcel.map((item) => {
      return {
        'EMPRESA/FAZENDA': item.CZACDSCFAZ,
        'EMISSÃO': item.CF2EMISSAO,
        'NOTA FISCAL': item.CF2DOC,
        'SERIE': item.CF2SERIE,
        'COD. CLIENTE': item.CF2CLIENTE,
        'NOME': item.CNOMEFORCLI,
        'LOJA': item.CLOJAFORCLI,
        'ITEM NF': item.CD2ITEM,
        'PRODUTO': item.CD2COD,
        'DESCRIÇÃO': item.CB1DESC,
        'QUANTIDADE': item.ND2QUANT,
        'UNIDADE DE MEDIDA': item.CD2UM,
        'VLR. UNITÁRIO': item.ND2PRCVEN,
        'TOTAL': item.ND2TOTAL,
      }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Saidas_Fazendas`);
  };

}
